import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    letterSpacing: '0.3px',
  },
  item: {
    paddingLeft: 24,
    paddingRight: 24,
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#A2AAB3',
  },
  value: {
    color: '#5C8DF3',
    fontSize: '17px',
    lineHeight: '24px',
  },
}));

const ContactsContainer = ({
  phoneContacts,
  emailContacts,
  socialMedias,
}) => {
  const classes = useStyles();

  return (
    <>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.root}
      >
        {
          emailContacts.map((email) => (
            <ListItem
              alignItems="flex-start"
              key={email.contact}
              className={classes.item}
            >
              <ListItemText
                className={classes.label}
                primary={email.type}
              />
              <a
                className={classes.value}
                href={`mailto:${email.contact}`}
              >
                {email.contact}
              </a>
            </ListItem>
          ))
        }
        {
          phoneContacts.map((phone) => (
            <ListItem
              alignItems="flex-start"
              key={phone.contact}
              className={classes.item}
            >
              <ListItemText
                className={classes.label}
                primary={phone.type}
              />
              <a
                className={classes.value}
                href={`tel:${phone.contact}`}
              >
                {phone.contact}
              </a>
            </ListItem>
          ))
        }
        {
          socialMedias.map((media) => (
            <ListItem
              alignItems="flex-start"
              key={media.contact}
              className={classes.item}
            >
              <ListItemText
                className={classes.label}
                primary={media.type}
              />
              <a
                className={classes.value}
                href={media.contact}
                target="_blank"
                rel="noopener noreferrer"
              >
                {media.contact}
              </a>
            </ListItem>
          ))
        }
      </List>
    </>
  );
};

ContactsContainer.propTypes = {
  phoneContacts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  emailContacts: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  socialMedias: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ContactsContainer;
